import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-class-history-lookup',
  templateUrl: './class-history-lookup.component.html',
  styleUrls: ['./class-history-lookup.component.css']
})
export class ClassHistoryLookupComponent implements OnInit {

  constructor(private _router: Router) { }

  studentNumber: string;
  firstName: string;
  lastName: string;
  yearOfBirth: string;
  email: string;
  zipCode: string;
  phoneNumber: string;

  lookup() {
    console.log('searching for student...');
    this._router.navigate(['past-student-info']);
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/class-history-lookup/class-history-lookup.component.ts